import { INLINE } from '../generated/inlineImages';

export type CumbreMilestonePhoto = {
  src: string;
  alt: string;
  caption: string;
};

export type CumbreMilestone = {
  title: string;
  body: string;
  note?: string;
  emphasis?: 'next' | 'finale';
  photo?: CumbreMilestonePhoto;
};

export const CUMBRE_RUTA: CumbreMilestone[] = [
  {
    title: 'I Cumbre Nacional — Lima 2025',
    body: 'Realizada el 7 y 8 de noviembre, reunió a más de 150 líderes provenientes de 14 ciudades del Perú.',
  },
  {
    title: 'Inicio de la descentralización nacional',
    body: 'En 2026 se puso en marcha una ruta de tres cumbres macroregionales: Norte, Centro y Sur.',
  },
  {
    title: 'Cumbre Macroregional del Norte — Chimbote',
    body: 'Realizada el sábado 30 de mayo de 2026, reunió a más de 100 líderes en la Iglesia Restauración Familiar.',
    photo: {
      src: INLINE.rutaNorte,
      alt: 'Participantes de la Cumbre Macroregional del Norte en Chimbote',
      caption: 'Norte — Áncash',
    },
  },
  {
    title: 'Cumbre Macroregional del Centro — Huancayo',
    body: 'Realizada el sábado 18 de julio de 2026 en el Lugar de la Memoria Yalpana Wasi.',
    photo: {
      src: INLINE.rutaCentro,
      alt: 'Participantes de la Cumbre Macroregional del Centro en Huancayo',
      caption: 'Centro — Junín',
    },
  },
  {
    title: 'Cumbre Macroregional del Sur — Arequipa',
    body: 'Realizada el sábado 26 de septiembre de 2026 en el Colegio Químico Farmacéutico Departamental de Arequipa.',
    photo: {
      src: INLINE.rutaSur,
      alt: 'Participantes de la Cumbre Macroregional del Sur en Arequipa',
      caption: 'Sur — Arequipa',
    },
  },
  {
    title: 'II Cumbre Nacional — Lima 2026',
    body: 'La ruta culminará los días 13 y 14 de noviembre en Lima, Perú, reuniendo a las redes construidas en el norte, centro y sur del país.',
    note: 'Para la cumbre nacional de este año esperamos a más de 300 líderes.',
    emphasis: 'next',
  },
];
